<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <detail-list :col="2">
          <!-- <detail-list-item term="区域名称">{{model.userAreaName}}</detail-list-item> -->
          <detail-list-item :term="$t('用户地址')" style="width: 50%;">{{model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</detail-list-item>
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <!--<detail-list-item term="表类型">{{model.userName}}</detail-list-item>-->
          <!-- <detail-list-item term="用户地址">{{model.userAddr}}</detail-list-item> -->
          <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
          <detail-list-item :term="$t('用户编号')">{{model.meterUserId}}</detail-list-item>
          <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
          <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
          <detail-list-item :term="$t('当前余额(元)')"><span :style="{color: model.userAccountNum!=null&&model.userAccountNum<0?'red': ''}">{{model.userAccountNum}}</span></detail-list-item>
          <detail-list-item :term="$t('阀门状态')">{{Mn100FkStatusObj[model.meterValveStatus]?Mn100FkStatusObj[model.meterValveStatus]:'--'}}</detail-list-item>
          <detail-list-item :term="$t('充值次数')">{{model.userPayTimes?model.userPayTimes:0}}</detail-list-item>
          <detail-list-item :term="$t('当前价格信息')">{{model.wtName}}({{model.wtTotalPrice}}{{ $t('元') }})</detail-list-item>
          <detail-list-item :term="$t('报警金额(元)')">{{model.wtAlarmMoney}}</detail-list-item>
          <detail-list-item :term="$t('透支金额(元)')">{{model.wtOverdrafTmoney}}</detail-list-item>
          <detail-list-item :term="$t('当前计费阶级')">{{model.userCurrentStep}}</detail-list-item>
          <detail-list-item :term="$t('当前阶梯使用量(m³)')">{{model.userCurrentStepUse}}</detail-list-item>
          <detail-list-item :term="$t('开始计费读数(m³)')">{{model.userStartCalNum}}</detail-list-item>
      </detail-list>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import DetailList from '@/components/tools/DetailList'
  import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUserAccountForm',
    components: {
      JFormContainer,
      DetailList,
      DetailListItem
    },
    data () {
      return {
        Mn100FkStatusObj,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUserAccount/add",
          edit: "/jeecg-charge/meter/meterUserAccount/edit",
          queryById: "/jeecg-charge/meter/meterUserAccount/queryById"
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>